import { Button } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)<{ $checked: boolean }>`
    svg {
        font-size: 20px;
        color: ${({ theme, $checked }) =>
            $checked
                ? theme.successTypographyColor
                : theme.primaryTypographyColor};
    }
`;

export const StyledScannerContainer = styled.div`
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    background: ${({ theme }) => theme.colors.black};

    video {
        height: 100%;
        width: 100%;
    }
`;
